import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { useGetPlanTrialData } from './use-get-plan-trial-data';
import { useHasDismissedBanner } from './use-has-dismissed-banner';
import { TRIALED_PLAN_TO_SATISFYING_UPGRADE_PLAN_IDS } from './plan-trial-constants';

/**
 * Determines if the billing plan trial banner should be shown.
 * Shows when:
 * - Seller has an active plan trial
 * - User hasn't upgraded to the trialed tier (or higher)
 * - User hasn't dismissed for this specific tier within 7 days
 */
export const useShouldShowPlanTrialBanner = (): boolean => {
  const { isInPlanTrial, activePlanCode } = useGetPlanTrialData();
  const { currentBillingPlan } = useSelector(Global.selectSellerSubscriptionData) ?? {};
  const billingPlanId = Number.parseInt(currentBillingPlan?.billingPlanId ?? 0, 10);
  const hasDismissedForThisTier = useHasDismissedBanner(activePlanCode);

  const satisfyingPlanIds = TRIALED_PLAN_TO_SATISFYING_UPGRADE_PLAN_IDS[activePlanCode] ?? [];
  const hasUpgradedToTrialedTierOrHigher = satisfyingPlanIds.includes(billingPlanId);

  return isInPlanTrial && !hasUpgradedToTrialedTierOrHigher && !hasDismissedForThisTier;
};
